import { useDisclosure } from "@msuite/ui/hooks";
import { createStandardMenuItems, Menu } from "@msuite/ui/menu";
import { type CellContext, RowActionsWrapper, useDataTableContext } from "@msuite/ui/table";
import { Fragment } from "@msuite/ui/utils";
import type { Tables } from "@msuite/utils/types";
import { EditArticleProductTypeModal } from "@/modals/stock/edit-article-product-type-modal";
import { useCitadel } from "@/hooks/use-citadel";

export function RowActions({ cell }: CellContext<Tables<"articleProductTypes">, "actions">) {
	/** Context */
	const { refetch } = useDataTableContext();

	/** Hooks */
	const disclosure = useDisclosure();

	/** Query */
	const { citadel } = useCitadel();

	/** Computed */
	// The menu is an array of items, so the gate sits at the caller rather than in
	// a `<Can>` wrapper — same three-state guard as that component documents
	// (`apps/web/src/components/citadel/can.tsx`): dropped only on a definitive
	// denial, kept while the rules load so the server has the last word.
	const stockUpdateIsDenied = !!citadel && citadel.cannot("update", "Stock");

	/** Render */
	return (
		<Fragment>
			<RowActionsWrapper to={null}>
				{!stockUpdateIsDenied && (
					<Menu
						items={createStandardMenuItems({
							onEdit: disclosure.onOpen,
						})}
					>
						<Menu.Button />
					</Menu>
				)}
			</RowActionsWrapper>
			{disclosure.isOpen && (
				<EditArticleProductTypeModal
					isOpen={disclosure.isOpen}
					onClose={disclosure.onClose}
					onComplete={refetch}
					articleProductTypeId={cell.row.original.id}
				/>
			)}
		</Fragment>
	);
}
